// Module
var code = "<template> <new-typeahead data.bind=\"countryList\" selected-option.bind=\"selectedCountry\" validation.bind=\"validation\" placeholder=\"Type to Search Country...\" disabled.bind=\"disabled\"> <template replace-part=\"label\"> <span class=\"flag-icon fi-${twoLetterCode.toLowerCase()} me-1\"></span> </template> </new-typeahead> </template> ";
// Exports
export default code;